import styled from 'styled-components';

export const CardContainer = styled.div`
  max-width: 383px;
  margin-bottom: ${props => props.theme.spacing(2)};
  @media ${props => props.theme.tablet} {
    justify-self: ${props => props.$align};
    margin-bottom: 0;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${props => props.$contentAlignment};
  margin-top: ${props => props.theme.spacing(4)};
  text-align: ${props =>
    props.$contentAlignment === 'center' ? 'center' : 'left'};
  gap: ${props => props.theme.spacing(4)};
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  ${props => props.theme.fontFamily.base}
`;

export const NumberCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.theme.spacing(8)};
  height: ${props => props.theme.spacing(8)};
  margin-right: ${props => props.theme.spacing(2)};
`;

export const BodyWrapper = styled.p`
  ${props => props.theme.typography.body};
  ${props => props.theme.fontFamily.base}
`;

export const BadgeContainer = styled.div`
  display: flex;
  position: absolute;
  margin-top: 20px;
  margin-left: 20px;
  z-index: 1;
`;
